import { useQuery } from 'react-query';

//consts
import { QUERY_KEYS } from 'consts/queryKeys';
//services
import {
  getReservationPayments,
  getReservationServices,
  getReservationType,
} from 'modules/accommodations/features/reservations/api';

interface IProps {
  reservationId: string;
  reservationType?: string;
}

export const useQueryReservationDetailsTab = ({
  reservationId,
  reservationType = 'REZ',
}: IProps) => {
  const {
    error: errGeneral,
    data: general,
    isLoading: isLoadingGeneral,
  } = useQuery([QUERY_KEYS.UNITS_RESERVATION_TYPE, reservationId, reservationType], () =>
    getReservationType(reservationId, reservationType),
  );

  const {
    error: errPayments,
    data: payments,
    isLoading: isLoadingPayments,
  } = useQuery([QUERY_KEYS.UNITS_RESERVATIONS_PAYMENTS, reservationId], () =>
    getReservationPayments(reservationId),
  );

  const {
    data: services,
    isLoading: isLoadingServices,
    isError: isErrorServices,
  } = useQuery([QUERY_KEYS.UNITS_RESERVATION_SERVICES, reservationId], () =>
    getReservationServices(reservationId),
  );

  return {
    isError: errGeneral || errPayments || isErrorServices,
    data: {
      general,
      payments,
      services,
    },
    isLoading: isLoadingGeneral || isLoadingPayments || isLoadingServices,
  };
};
